import React from "react";
import CWP from "@components/CWP/CWP";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";

/**
 * CWP Page
 * Displays dealer location and CWP information
 */
const CWPPage = () => {
  usePageInitialization();

  return (
    <PageLayout title="Dealer Locator" backPath="/">
      <CWP />
    </PageLayout>
  );
};

export default CWPPage;
